import {
  CalendarBlankIcon,
  CalendarIcon,
  ProfileIcon,
  TimerIcon,
} from '@bunce/icons'
import type { SelectItemProps } from 'radix-vue'

export const ZoomRate = 0.15
export const ActionNodeWidth = 500
export const ActionNodeHeight = 110
export const ActionNodeIconXPosition = ActionNodeWidth - 50
export const ActionNodeIconYPosition = 10
export const ActionNodeTypeTextPadding = 10
export const ActionNodeTypeFontSize = 15
export const AutomationStageDefaultScale = 0.6
export const AutomationActionIconTrigger = '/images/campaign-action-trigger.svg'
export const AutomationActionIconAction = '/images/campaign-action-action.svg'
export const AutomationActionIconControl = '/images/campaign-action-control.svg'
export const AutomationActionIconControlDelay =
  '/images/campaign-action-control-delay.svg'

export const AutomationStepBranchRight = 'BranchRight'

export const AutomationStepBranchLeft = 'BranchLeft'

export const AutomationStepBranchNoBranch = 'NoBranch'
export const AutomationStepBranchDirection = {
  [AutomationStepBranchRight]: AutomationStepBranchRight,
  [AutomationStepBranchLeft]: AutomationStepBranchLeft,
  [AutomationStepBranchNoBranch]: AutomationStepBranchNoBranch,
} as const

export const AutomationContainerBorderColor = '#A6A2A2'

export const CampaignTriggersData = [
  {
    title: 'When a customer enters a segment',
    icon: ProfileIcon,
    value: 'segment',
    description:
      'This campaign is best for personalized marketing to customers within a segment',
    tip: 'Learn how to use segment triggers',
  },
  {
    title: 'When an event occurs',
    icon: TimerIcon,
    value: 'event',
    description:
      'This campaign is best for proactively reaching out to customers when they take an action in your app',
    tip: 'Learn how to use event triggers',
  },
  {
    title: 'For transactional messages',
    icon: CalendarIcon,
    value: 'transactional_message',
    description: 'Best for follow ups on transactional ',
    tip: 'Learn how to use date triggers',
  },
  {
    title: 'For important dates',
    value: 'date',
    icon: CalendarBlankIcon,
    description:
      'Best for date specific events like birthdays ,holidays, reminders and celebrations',
    tip: 'Learn how to use date triggers',
  },
] as const

export const CampaignTriggersDateData = [
  {
    title: 'Choose a specific date',
    icon: CalendarBlankIcon,
    value: 'specific_date',
    description:
      'Choose a specific date and time you want your campaign triggered',
    tip: 'Learn how to use specific date',
  },
  {
    title: 'Choose a custom date',
    icon: CalendarBlankIcon,
    value: 'custom_date',
    description:
      'Choose date related attribute or events that will trigger your campaign',
    tip: 'Learn how to use custom date',
  },
] as const

export const CampaignActionOptions = [
  { label: 'Send E-mail', value: 'email' },
  { label: 'Send SMS', value: 'sms' },
  {
    label: 'Push Notification',
    value: 'push_notification',
  },
  {
    label: 'Slack',
    value: 'slack-message',
    attrs: { disabled: true },
  },
  {
    label: 'Send WhatsApp Message',
    value: 'whatsapp',
  },
] as const

export const CampaignDelayOptions = [
  { label: 'Time Delay', value: 'delay' },
] as const

export const CampaignControlOptions = [
  { label: 'Condition', value: 'condition' },
  { label: 'Multi Condition', value: 'multi-condition' },
  {
    label: 'Transaction Check',
    value: 'transaction_check',
    attrs: { disabled: true },
  },
  {
    label: 'Payment Processor Check',
    value: 'payment_processor_check',
    attrs: { disabled: true },
  },
  { label: 'Go-To Step', value: 'goto' },
] as const

export const CampaignExitOptions = [
  {
    value: 'goal_met',
    title: 'Customers meet the campaign goal',
    tooltip: '',
  },
  {
    value: 'complete',
    title: 'Customers do not exit early but go through the entire flow',
    tooltip: '',
  },
] as const

export const CampaignFrequencyOptions = [
  {
    value: 'once',
    title: 'Send Once',
    tooltip: `Customers will only go through this <br />
      Campaign the first time they meet the <br />
      trigger condition. They cannot enter the <br />
      second time.`,
  },
  {
    value: 'everytime',
    title: 'Send Everytime',
    tooltip: `Send everytime - Customers will keep <br /> going through this campaign everytime <br /> they meet the trigger condition.`,
  },
  {
    value: 'complete',
    title: 'Intervals',
    tooltip: `Send at fixed interval -  As long as <br /> customers meet the trigger condition this <br /> campaign will be sent but only within a <br /> fixed interval or time delay.`,
  },
] as const

export const CampaignGoalActions: Array<SelectItemProps> = [
  { value: 'none', textValue: 'No Goal' },
  { value: 'event', textValue: 'Perform Event' },
  { value: 'enter_segment', textValue: 'Enter Segment' },
  { value: 'leave_segment', textValue: 'Leave Segment' },
  // { value: 'transaction', textValue: 'Transaction Value' },
] as const

export const WorkflowNodeWidth = 350
